import { useCallback, useEffect, useRef, useState } from 'react';
import { useWebSocketContext } from '../contexts/WebSocketProvider';

export default function useTotalEarnings(selectedMonth, selectedYear) {
  const [totalEarnings, setTotalEarnings] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const { send, isConnected, registerHandler } = useWebSocketContext();
  const mountedRef = useRef(true);
  
  const groupId = localStorage.getItem("group_id");

  const fetchTotalEarnings = useCallback(async () => {
    // Only run if we have a connection and the component is mounted
    if (!mountedRef.current || !isConnected) return;

    setIsLoading(true);
    setError('');

    try {
      // Use passed values or fallback to current date if not provided
      const now = new Date();
      const finalMonth = selectedMonth || (now.getMonth() + 1);
      const finalYear = selectedYear || now.getFullYear();

      const payload = {
        group_id: groupId?.toString(),
        month: parseInt(finalMonth), 
        year: parseInt(finalYear),
      };

      console.log("Requesting earnings for:", payload);

      const response = await send('cms_get_total_earnings_by_group_id', payload);

      if (!response || response.type !== 'cms_get_total_earnings_by_group_id_response') {
        throw new Error('Invalid response from server');
      }

      const earningsValue = Number(response.data);
      setTotalEarnings(isNaN(earningsValue) ? 0 : earningsValue);

    } catch (err) {
      console.error("Earnings Fetch Error:", err);
      setError(err.message);
    } finally {
      if (mountedRef.current) setIsLoading(false);
    }
    // Dependency array uses primitives (month/year) which are stable
  }, [isConnected, send, groupId, selectedMonth, selectedYear]);

  // Live updates
  useEffect(() => {
    const unregister = registerHandler('earnings_update', (msg) => {
      if (msg && msg.total_earnings !== undefined && mountedRef.current) {
        setTotalEarnings(Number(msg.total_earnings));
      }
    });
    return () => unregister();
  }, [registerHandler]);

  // Initial fetch and refetch on change
  useEffect(() => {
    mountedRef.current = true;
    fetchTotalEarnings();
    return () => { mountedRef.current = false; };
  }, [fetchTotalEarnings]);

  return { totalEarnings, isLoading, error, refetch: fetchTotalEarnings };
}